import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18ca36df"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "title content-title" }, "1.テンプレートをダウンロード", -1))
const _hoisted_3 = { class: "area-template" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ダウンロード ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "explan-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, "テンプレートに沿ってメタデータを入力してください。")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_AppButton, {
        onClick: _ctx.download,
        onKeydown: _withKeys(_withModifiers(_ctx.download, ["prevent"]), ["space","enter"]),
        buttonId: 'button-download'
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick", "onKeydown"])
    ]),
    _hoisted_5
  ]))
}